"use client";
import Image from "next/image";

const Achievements = () => {
  return (
    <div>
      <section className="py-10 md:py-16">
        <div className="max-w-screen-xl mx-5 lg:mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 lg:gap-16 items-center justify-between mb-6 md:mb-12 lg:mb-16">
            <div>
              <h2 className=" font-medium text-color-blue-600 my-3">
                Our Achievements
              </h2>
              <h5 className="font-bold text-black mb-4">Patent</h5>
              <p>
                Awarded “Patent” by Singapore Government for Travel Software.
                This software helps us to cater services of highest quality to
                our customers.
              </p>
              <h5 className="font-bold text-black mb-4">
                Non-Stop in Covid Era
              </h5>
              <p>
                During the Covid times when travel industry was going through
                turbulences, Arranging chartered flights for marine crew.
              </p>
              <h5 className="font-bold text-black mb-4">
                Non-Stop in War Times
              </h5>
              <p>
                During Russia-Ukraine war times, when no travel agent was able
                to issue tickets for Russia sectors, made sure, tickets are
                arranged to facilitate passenger movements in and out of Russia.
              </p>
              <h5 className="font-bold text-black mb-4">Awards</h5>
              <ul className="list-disc ml-4 mb-4">
                <li>Received MSME Award 2022 for “Fastest Growing Business”</li>
              </ul>
            </div>
            <div className="relative w-full h-full">
              <Image
                src="/images/achievements.jpg"
                alt="Achievements Image"
                fill
                className="object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Achievements;
